import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Partner } from 'src/app/models/partner.schema';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { PartnerService } from 'src/app/services/partner.service';
import { FormControl, FormGroup } from '@angular/forms';
import { InvoiceService } from 'src/app/services/invoice.service';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { CommanUsesService } from './../../services/comman-uses.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {

  groups: any;
  partners: Partner[] = [];
  selectedPartner: Partner;
  selectedPartnerId: any = null;

  invoiceFilterForm: any;
  order: {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'DeliveryInvoice.id': 'DESC' };
  filtered = {};

  /*
  invoices = [
    {
      id: 1,
      receiptStatus: 'open',
      totalAmount: 100,
      createdAt: new Date('2023-09-20'),
      expert: {
        user: {
          surname: 'Doe',
          name: 'John'
        }
      },
      toReceipt: 'toReceiptUrl1',
      fromReceipt: 'fromReceiptUrl1',
      deliveries: [
        {
          id: 10001
        },
        {
          id: 10002
        },
        {
          id: 10003
        },
        {
          id: 10004
        },
      ]
    },
    {
      id: 2,
      receiptStatus: 'approved',
      totalAmount: 200,
      createdAt: new Date('2023-09-18'),
      expert: {
        user: {
          surname: 'Smith',
          name: 'Jane'
        }
      },
      toReceipt: 'toReceiptUrl2',
      fromReceipt: 'fromReceiptUrl2',
      deliveries: [
        {
          id: 10005
        }
      ]
    },
    {
      id: 3,
      receiptStatus: 'paid',
      totalAmount: 150,
      createdAt: new Date('2023-09-15'),
      expert: {
        user: {
          surname: 'Johnson',
          name: 'Emily'
        }
      },
      toReceipt: 'toReceiptUrl3',
      fromReceipt: 'fromReceiptUrl3',
      deliveries: [
        {
          id: 10009
        },
        {
          id: 10010
        }
      ]
    }
  ];
  */
 invoices: any[] = [];
  activeAccordionActivityIndex: number | null = null;
  selected: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private partnerService: PartnerService,
    private authStatusService: AuthStatusService,
    private commanUsesService: CommanUsesService,
    private spinnerService: SpinnerService,
  ) { 
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.manageDeliveryInvoiceFilterForm();
  }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      this.partners = await this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners) ?? [];
      const loggedInUserInfo = await this.authStatusService.getTokenInfo();

      if(this.groups.includes('partner')) {
        this.selectedPartner = await this.partnerService.getOne(loggedInUserInfo['extraId']);
        this.selectedPartnerId = this.selectedPartner?.id;

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { partnerId: this.selectedPartnerId },
          queryParamsHandling: 'merge',
        });
      } else {
        this.route.queryParams.subscribe(async (params) => {
          if (params['partnerId']) {
            this.selectedPartnerId = +params['partnerId'];
            this.selectedPartner = this.partners.find(v => v.id === this.selectedPartnerId);
          }
        });
      }

      await this.filter();
      this.spinnerService.hide();
    } catch (error) {
      const errorMsg: string = error?.error?.message || 'SOMETHING_WENT_WRONG';
      this.commanUsesService.showSnackBar(errorMsg);
      this.spinnerService.hide();
    }
  }

  manageDeliveryInvoiceFilterForm(){
    this.invoiceFilterForm = new FormGroup({
      'DeliveryInvoice.id': new FormControl('')
    })
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.invoiceFilterForm);
    this.filtered = {};
    if (filterForm['DeliveryInvoice.id'])
      this.filtered['DeliveryInvoice.id'] = filterForm['DeliveryInvoice.id'];  
    await this.loadDeliveryInvoices();
  }

  async loadDeliveryInvoices(limit?: number, page?: number, order?: {}) {
    try {
      if(this.selectedPartnerId) {
        this.filtered['Partner.id'] = this.selectedPartnerId;
        this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
        this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
        this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
        const invoices = await this.invoiceService.getAllDeliveryInvoices(this.page, this.limit, this.order, this.filtered);
        this.invoices = invoices.deliveryInvoices;
        console.log("this.invoices", this.invoices)
        this.count = invoices.count;
        this.maxPage = Math.ceil(this.count / this.limit);
      } 
    } catch (error) {
      console.log("ERROR_IN_loadCollections", error?.message);
    }
  }

  async handlePartnerChange(partnerId: number) {
    try {
      this.selectedPartner = this.partners.find(v => v.id === Number(partnerId));
      this.selectedPartnerId = this.selectedPartner?.id;
      this.router.navigate([], {
        queryParams: { partnerId: this.selectedPartnerId },
        queryParamsHandling: 'merge'
      });
      await this.loadDeliveryInvoices();
    } catch (error) {
      
    }
  }

  toggleAccordion(index?: number){
    if (this.activeAccordionActivityIndex === index) {
      this.activeAccordionActivityIndex = null;
    } else {
      this.activeAccordionActivityIndex = index; 
    }
  }

  handleApproveClick(expertReceipt: any, event: any) {
    console.log('Approve clicked for receipt:', expertReceipt);
  }

  handlePaidClick(expertReceipt: any, event: any) {
    console.log('Paid clicked for receipt:', expertReceipt);
  }

  handleReceiptUpload(event: any, expertReceipt: any) {
    console.log('Receipt uploaded for:', expertReceipt);
  }

  openInvoice(url: string) {
    window.open(url, '_blank');
  }

  async loadInvoices(limit?: number, page?: number, order?: {}) {
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    /*
    let collections = await this.collectionService.getAllShopCollections(this.page, this.limit, this.order, this.filtered);
    this.collections = collections.collections;
    this.count = collections.count;
    this.maxPage = Math.ceil(this.count / this.limit);
    */
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public async navigateOrder(attribute: string | string[]) {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadInvoices();
    });
  }

  async navigate(event) {
    await this.loadInvoices(event.limit, event.page, this.order);
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

}
